import { render, staticRenderFns } from "./DNNProfileTableMenu.vue?vue&type=template&id=148f7d08&scoped=true&"
import script from "./DNNProfileTableMenu.vue?vue&type=script&lang=js&"
export * from "./DNNProfileTableMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148f7d08",
  null
  
)

export default component.exports